import { userConstants } from './../constants/user.constants';

const initialState = {};

export function POSTACTIVITY(state = initialState, action) {
  switch (action.type) {
    case userConstants.POST_ACTIVITY_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.POST_ACTIVITY_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.POST_ACTIVITY_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}